<template lang="html">
  <ul class="banner">
    <li v-for="(banner,key) in banners" :key="key" :class="iscustom?'crm' : ''" :style="{'background':'url('+banner.imgUrl+')','background-size': 'cover','backgroundPosition': bgPosition}">
      <p class="title" v-html="iscustom?banner.title: titleToUpperCase(banner.title)"></p>
      <p class="description">{{banner.description}}</p>
      <!-- <img :src="" alt=""> -->
    </li>
  </ul>
</template>

<script>
export default {
  name: 'bannerTop',
  props:{
    banners:{
      type: Array,
      default: ()=>{
        return []
      }
    },
    iscustom:{
      type: Boolean,
      default: false
    },
    bgPosition:{
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="css">
</style>
